import highEmphasis from '../../../../text/high-emphasis';

const dark = (params) => highEmphasis(params);

export default dark;
